import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import imageCompression from 'browser-image-compression';
import Swal from 'sweetalert2';

const ImageCropperModal = ({ show, imageFile, onSave, onClose }) => {
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (imageFile) {
            processImage(imageFile);
        }
    }, [imageFile]);

    const processImage = async (file) => {
        setIsSaving(true);
        try {
            // Convertir la imagen a Blob en formato webp y comprimirla
            const compressedBlob = await imageCompression(file, {
                maxSizeMB: 1, // Reducir tamaño si es necesario
                maxWidthOrHeight: 1024, // Escalar la imagen manteniendo proporciones
                useWebWorker: true,
                fileType: 'image/webp' // Forzar conversión a webp
            });

            const fileName = `reymidas_${Date.now()}.webp`;
            const compressedFile = new File([compressedBlob], fileName, { type: 'image/webp' });

            onSave(compressedFile);
        } catch (error) {
            console.error('Error al procesar la imagen:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al procesar la imagen.',
            });
        } finally {
            setIsSaving(false);
            onClose(); // Cerrar el modal automáticamente después de procesar
        }
    };

    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered>
            <Modal.Header>
                <Modal.Title>Procesando Imagen</Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>
                <Spinner animation='border' role='status' variant='danger'>
                    <span className='sr-only visually-hidden'>Cargando...</span>
                </Spinner>
                <p>Convirtiendo y comprimiendo imagen...</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={onClose} disabled={isSaving}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ImageCropperModal;
